import { take, takeLatest, put, call, fork, select } from 'redux-saga/effects'

import { indicateProgress } from 'api'
import { userSelector } from 'auth/selectors'
import { amendCartReservation } from 'grs/api'
import { apiLanguageCodeSelector } from 'i18n/selectors'
import { rateSelector } from 'booking/selectors'
import { extendPurchaseCompleted, clearPurchaseCompleted } from 'booking/actions'
import { LOCATION_CHANGE } from 'browser-location'

import * as constants from './constants'
import { extendedReservation, failedReservationExtension } from './actions'

export function* extendReservation({ reservation, history }) {
    const {
        token,
        email,
        details: {
            firstName,
            lastName,
            phone,
            address: { address1, city, postalCode, state },
        },
    } = yield select(userSelector)
    const apiLanguageCode = yield select(apiLanguageCodeSelector)
    const { actualFromDateISO, actualToDateISO, fromDateISO, toDateISO } = yield select(rateSelector)
    try {
        yield call(
            indicateProgress,
            'extendReservation',
            amendCartReservation,
            token,
            {
                ...reservation,
                apiLanguageCode,
                email,
                actualFromDateISO,
                actualToDateISO,
                fromDateISO,
                toDateISO,
                firstName,
                lastName,
                phone,
                address1,
                city,
                postalCode,
                state,
            },
            apiLanguageCode
        )
        yield put(extendedReservation(history))
    } catch (exception) {
        yield put(failedReservationExtension(exception.message))
    }
}

export function* watchExtendReservation() {
    yield takeLatest(constants.EXTEND_RESERVATION, function* (action) {
        try {
            yield call(extendReservation, action)
        } catch (error) {}
    })
}

export function* watchExtendedReservation() {
    yield takeLatest(constants.EXTENDED_RESERVATION, function* ({ history }) {
        try {
            history.push('basket')
            yield put(extendPurchaseCompleted())
            yield take(LOCATION_CHANGE)
            yield put(clearPurchaseCompleted())
        } catch (error) {}
    })
}

export default function* rootSaga() {
    yield fork(watchExtendReservation)
    yield fork(watchExtendedReservation)
}
